export const SEARCH_PLACEHOLDER = 'Анализ, например: Витамин Д'
